module.exports = __webpack_public_path__ + "img/light-blue-circle.a7f8c6f9.svg";